import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { Observable } from 'rxjs';
import { FraccionamientoCatalogo } from '../../model/catalogo.model';
import { TipoCliente } from '../../model/salud.model';

@Injectable({
  providedIn: 'root'
})
export class CatalogoSaludApiService extends BaseApiService{

  getFraccionamientos(codIdioma: string): Observable<FraccionamientoCatalogo[]> {
      return this.invocarSeguros<FraccionamientoCatalogo[]>('GET', `salud/catalogo/fraccionamientos/${codIdioma}`);
  }

  getTiposCliente(): Observable<TipoCliente[]> {
      return this.invocarSeguros<TipoCliente[]>('GET', 'salud/catalogo/tipos-cliente');
  }
}
